// extracted by mini-css-extract-plugin
export var imgWrapper = "join-box-module--imgWrapper--93231";
export var joinBox = "join-box-module--join-box--f20e5";
export var joinContainer = "join-box-module--join-container--2e1e4";